import { forwardRef, useId } from 'react';
import { MdClose, MdSearch } from 'react-icons/md';

type SearchInputProps = {
  label: string;
  value?: string;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onClear?: () => void;
  inputId?: string;
  inputName?: string;
  className?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  function SearchInput(props, ref) {
    const {
      label,
      value,
      onSubmit,
      onClear,
      inputId,
      inputName = 'search-input',
      className,
      ...inputProps
    } = props;

    const autoId = useId();
    const resolvedId = inputId ?? autoId;
    const showRenderClearButton = !!value && onClear;

    return (
      <form
        onSubmit={onSubmit}
        className={`flex w-full max-sm:flex-col sm:items-center ${className ?? ''}`}
      >
        <label
          htmlFor={resolvedId}
          className="whitespace-nowrap max-sm:hidden sm:flex sm:items-center sm:h-10 sm:px-4 sm:py-2
            sm:rounded-tl-lg sm:rounded-bl-lg sm:border sm:border-solid
            sm:border-neutral-300 sm:border-r-0 text-sm text-neutral-500"
        >
          {label}
        </label>

        <div className="flex w-full">
          <div className="relative flex-grow">
            <input
              ref={ref}
              id={resolvedId}
              name={inputName}
              defaultValue={value}
              className="h-10 w-full px-3 py-2 pr-8 bg-neutral-100 border border-solid border-neutral-300
                max-sm:rounded-tl-lg max-sm:rounded-bl-lg sm:border-r-0 outline-none
                max-sm:placeholder:text-neutral-400 max-sm:placeholder:text-sm
                sm:placeholder:text-transparent"
              placeholder={label}
              {...inputProps}
            />

            {showRenderClearButton && (
              <button
                type="button"
                onClick={onClear}
                aria-label="Limpar campo"
                title="Limpar"
                className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-400
                  hover:text-neutral-600 focus:outline-none focus:ring-2 focus:ring-neutral-300
                  rounded"
              >
                <MdClose size={16} />
              </button>
            )}
          </div>

          <button
            type="submit"
            aria-label="Buscar"
            title="Buscar"
            className="flex items-center justify-center size-10 rounded-tr-lg rounded-br-lg
              bg-neutral-500"
          >
            <MdSearch className="text-neutral-100" size={20} />
          </button>
        </div>
      </form>
    );
  }
);
